import axios from 'axios';
import authStorage from '../utils/authStorage';
import config from '../config';

// Get API base URL from environment or use default
const API_BASE_URL = config.api.apiUrl;

// Create axios instance with default config
const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 30000, // 30 seconds
    withCredentials: false,
});

// Helpers to keep headers aligned with apiService
const getActiveAgentId = () => {
    try {
        const primaryKey = 'Nixia_active_agent_id';
        const legacyKey = 'nixia_active_agent_id';
        const agentId = localStorage.getItem(primaryKey) || localStorage.getItem(legacyKey);
        return agentId || null;
    } catch {
        return null;
    }
};

// Request interceptor to add auth token
api.interceptors.request.use(
    (config) => {
        const token = authStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        
        // Add agent header if available
        const agentId = getActiveAgentId();
        if (agentId) {
            config.headers['X-Agent-Id'] = agentId;
        }

        const isFormData =
            typeof FormData !== 'undefined' &&
            (config.data instanceof FormData ||
                Object.prototype.toString.call(config.data) === '[object FormData]');
        if (isFormData) {
            if (typeof config.headers?.delete === 'function') {
                config.headers.delete('Content-Type');
                config.headers.delete('content-type');
            } else if (config.headers) {
                delete config.headers['Content-Type'];
                delete config.headers['content-type'];
            }
            delete config.headers?.common?.['Content-Type'];
            delete config.headers?.common?.['content-type'];
            delete config.headers?.post?.['Content-Type'];
            delete config.headers?.post?.['content-type'];
            delete config.headers?.put?.['Content-Type'];
            delete config.headers?.put?.['content-type'];
            delete config.headers?.patch?.['Content-Type'];
            delete config.headers?.patch?.['content-type'];
        }
        
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor to handle errors
api.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response) {
            // Server responded with error status
            const { status, data } = error.response;
            
            if (status === 401) {
                // Unauthorized - clear token and redirect to login
                authStorage.removeItem('token');
                authStorage.removeItem('user');
                window.location.href = '/admin/login?expired=true';
            }
        } else if (error.request) {
            // Request made but no response received
        } else {
            // Error in request setup
        }
        
        return Promise.reject(error);
    }
);

export default api;

